import { ApiAction } from '../../../../../types';
import { TotalTrips } from '../../../types';

import { fetchTotalTripsTypes } from '../../actions';

const initialState: TotalTrips[] = [];

export default (state = initialState, action: ApiAction) => {
    switch (action.type) {
        case fetchTotalTripsTypes.FETCH_TOTAL_TRIPS_SUCCESS: {
            const trips: TotalTrips[] = action.payload;

            return trips;
        }
        case fetchTotalTripsTypes.FETCH_TOTAL_TRIPS_RESET:
            return initialState;
        default:
            return state;
    }
};
